import { Color } from '@diritto/common/style/color';
import { ContentCoverFontList, Font } from 'constants/contentCover';
import { useImageEditor } from 'libs/DirittoImageEditor';
import { useCallback, useMemo, useState } from 'react';
import { shuffle } from '@diritto/common/utils/array';

export const useCoverImageEditor = (targetElement: HTMLElement | null, imageFilePath: string) => {
  const { activeObj, isLoaded, addText, changeTextColor, changeTextFont, clearObjects, getImageFile } = useImageEditor(
    targetElement,
    imageFilePath,
  );

  const fontFamilies = useMemo(() => shuffle(ContentCoverFontList), []);

  const [nowColor, setNowColor] = useState<string>(Color.White);
  const [nowFontFamily, setNowFontFamily] = useState(fontFamilies[0]);

  const selectedColor = useMemo(() => activeObj?.fill || nowColor || Color.White, [activeObj?.fill, nowColor]);
  const selectFontFamily = useMemo(
    () => (activeObj?.fontFamily as Font) || nowFontFamily || fontFamilies[0],
    [activeObj?.fontFamily, fontFamilies, nowFontFamily],
  );

  const changeFontColor = useCallback(
    (color: string) => {
      setNowColor(color);
      if (!activeObj?.id) {
        return;
      }
      changeTextColor(activeObj?.id, color);
    },
    [activeObj?.id, changeTextColor],
  );

  const changeFontStyle = useCallback(
    (fontFamily: Font) => {
      setNowFontFamily(fontFamily);
      if (!activeObj?.id) {
        return;
      }
      changeTextFont(activeObj?.id, fontFamily);
    },
    [activeObj?.id, changeTextFont],
  );

  return {
    isLoaded,
    selectedColor,
    selectFontFamily,
    fontFamilies,
    addText: () => addText('제목을 입력해주세요', selectedColor, selectFontFamily),
    changeFontColor,
    changeFontStyle,
    getImageFile,
    clearImageEditor: clearObjects,
  };
};
